
<template>
  <div class="recharge_wrap">
    <div class="red_top_bg">
      <div
        class="back_left"
        @click="$router.push('/user')"
      />
      <div class="big_tit">
        {{ $t('shopd.setshopaddr') }}
      </div>
    </div>
    <div
      v-if="addr"
      class="wrap_box warp1"
    >
      <div class="item">
        <div class="ari_font">
          {{ $t('shopd.name') }}：
        </div>
        <input
          v-model="addr.name"
          type="text"
          placeholder="No real name entered, please set"
        >
      </div>
      <div class="item">
        <div class="ari_font">
          {{ $t('shopd.phone') }}：
        </div>
        <input
          v-model="addr.tel"
          type="text"
          placeholder="No phone number entered, please set"
        >
      </div>
      <div class="item">
        <div class="ari_font">
          {{ $t('shopd.region') }}：
        </div>
        <input
          v-model="addr.region"
          type="text"
          placeholder="No region entered, please set"
        >
      </div>
      <div class="item">
        <div class="ari_font">
          {{ $t('shopd.address') }}：
        </div>
        <input
          v-model="addr.addr"
          type="text"
          placeholder="No detailed address entered, please set"
        >
      </div>
    </div>
    <div
      class="basic_btn"
      @click="submitBtn"
    >
      {{ $t('shopd.ok') }}
    </div>
  </div>
</template>

<script>
    import Vue from 'vue';
    import Fetch from '../../utils/fetch'

    export default {
        name: "Addr",
        data() {
            return {
                addr: {
                    name: '',
                    tel: '',
                    addr:'',
					region:''
                },
            };
        },
        created() {
            this.$parent.footer('user', false);
        },
        mounted() {
            this.start();
        },
        methods: {
			start(){
				Fetch('/user/my_addr').then(r=>{
					if(r.data && r.data.tel){
						this.addr = r.data;
					}
				})
			},
            submitBtn(){
				if (!this.addr.name.replace(/\s/g, "")) {
				    this.$notify("Name cannot be empty!");
				    return;
				}
				if (!this.addr.tel.replace(/\s/g, "")) {
				    this.$notify("Telephone cannot be empty!");
				    return;
				}
				if (!this.addr.addr.replace(/\s/g, "")) {
				    this.$notify("Detailed Address cannot be empty!");
				    return;
				}
                Fetch('/user/addr_add',{
                    ...this.addr
                }).then(r=>{
                    this.$toast({
                    	background: '#07c160',
                    	message: 'Added Success'
                    });
                    this.$router.push('/user');
                })
                
            }
        }
    };
</script>

<style lang="less" scoped>
    /deep/ .van-dropdown-menu {
        position: relative;
        z-index: 10;
        color: #CCCCCC;
    }

    /deep/ .van-dropdown-menu__bar {
        position: relative;
        z-index: 10;
        width: 211px;
        height: 34px;
        border: 1px solid #D9D9D9;
        border-radius: 4px;
        text-align: left;
    }

    /deep/ .van-dropdown-item--down {
        width: 211px;
        margin: 0 auto;
        z-index: 12;
        transform: translateX(4px);
    }

    /deep/ .van-dropdown-menu__item {
        justify-content: flex-start;
        color: #ccc;
        background-color: #fff;
    }

    /deep/ .van-dropdown-menu__title {
        width: 100%;
    }

    /deep/ .van-dropdown-menu__title::after {
        width: 13px;
        height: 22px;
        transform: none;
        background: url(../../assets/images/drop.png) no-repeat center center;
        background-size: 100% 100%;
        border: none;
        opacity: 1;
        margin-top: -11px;
        right: 10px;
    }

    /deep/ .van-cell {
        padding: 5px 8px;
    }

    /deep/ .van-cell__title {
        flex: 3;
        white-space: normal;
    }

    /deep/ .van-ellipsis {
        color: #000;
    }

    /deep/ .van-dropdown-item__option {
        color: #ccc;
        border: 1px solid #D9D9D9;
        border-bottom: none;
        border-radius: 4px;
    }

    /deep/ .van-dropdown-item__option:last-child {
        border-bottom: 1px solid #D9D9D9;
    }

    /deep/ .van-dropdown-item__option--active.van-dropdown-item__option {
        color: #000;

        .van-dropdown-item__icon {
            color: #E96259;
        }
    }

    .rela {
        position: relative;
        z-index: 11;
    }

    .warp1 {
        margin: 5vh 3vw;

        .item {
            height: 50px;
            padding: 0 3vw;
            font-size: 14px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            border-bottom: 1px solid #ECECEC;

            &:last-child {
                border-bottom: none;
            }

            input {
                line-height: 14px;
				width: 70vw;
            }
        }
    }

    .ari_font {
        width: 18vw;
        word-break: keep-all;
        white-space: nowrap;
        height: 20px;
        font-size: 14px;
        font-weight: 600;
        color: rgba(0,0,0,.8);
        line-height: 20px;
    }

    .basic_btn {
        margin: 5vh auto 0 auto;
    }
</style>
